import { PARTNER_STATUSES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { PartnersTableDefinitionZod } from '../tables';

export const PARTNERS_SORT_FIELDS = [
    'direct_partner_last_name',
    'direct_partner_company_name',
    'direct_partner_id',
    'lastChangedAt',
] as const;

export const PARTNERS_DEFAULT_LIMIT = 50;
export const PARTNERS_MAX_LIMIT = 200;

// Typed args instead of a raw mongo filter — the client must never be able to define the condition itself.
export const schemaPartnerResolver_GetPartnersArgs = z.object({
    // limit/offset arrive as strings over HTTP
    limit: z.coerce.number().int().positive().max(PARTNERS_MAX_LIMIT).optional().catch(undefined),
    offset: z.coerce.number().int().nonnegative().optional().catch(undefined),
    // plain strings, not nativeEnum: schemaPartner allows levels outside PARTNER_LEVELS
    partnerLevel: z.array(z.string().max(64)).optional().catch(undefined),
    // derived from the `locked` flag, so — unlike partnerLevel — this is a closed set
    partnerStatus: z.array(z.nativeEnum(PARTNER_STATUSES)).optional().catch(undefined),
    query: z.string().max(100).optional().catch(undefined),
    sortBy: z.enum(PARTNERS_SORT_FIELDS).optional().catch(undefined),
    sortOrder: z.enum(['ASC', 'DESC']).optional().catch(undefined),
});

export type SchemaPartnerResolver_GetPartnersArgs = z.infer<typeof schemaPartnerResolver_GetPartnersArgs>;

type Arguments = Partial<Record<keyof SchemaPartnerResolver_GetPartnersArgs, unknown>>;

export const schemaPartnerResolver_GetPartners = z.array(PartnersTableDefinitionZod);

export type SchemaPartnerResolver_GetPartners = z.infer<typeof schemaPartnerResolver_GetPartners>;
export type PartnerResolver_GetPartners = Resolver<Arguments, SchemaPartnerResolver_GetPartners>;
